import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, palette, shape }: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 13,
    padding: '16px 20px',
    fontWeight: 500,
    backgroundColor: custom.grey[9],
    color: custom.grey[3],
    border: `2px solid ${palette.common.white}`,
    borderRadius: shape.borderRadius,
  },
  icon: {
    color: palette.primary.main,
    fontSize: 33,
    marginRight: 15,
  },
  content: {
    maxWidth: 300,
    paddingRight: 20,
    lineHeight: 1.5,
  },
  aside: {
    textAlign: 'right',
    flexGrow: 1,
    lineHeight: 1.5,
  },
  title: {
    fontWeight: 'bold',
  },
  action: {
    color: palette.primary.main,
    cursor: 'pointer',
    display: 'inline-block',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));
